import type { SoundResourceType } from '../controllers/audioController/types';

import ChipClick from './assets/snd_ChipClick.mp3';
import MenuClick from './assets/snd_MenuClick.mp3';
import UndoClick from './assets/snd_UndoClick.mp3';

export const coreSoundResources: SoundResourceType[] = [
  {
    name: 'chipClick',
    url: ChipClick,
  },
  {
    name: 'reBet',
    url: ChipClick,
  },
  {
    name: 'doubleBet',
    url: ChipClick,
  },
  {
    name: 'menuClick',
    url: MenuClick,
  },
  {
    name: 'betOnAll',
    url: ChipClick,
  },
  {
    name: 'undoClick',
    url: UndoClick,
  },
];
